import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  label: {
    color: '#979FAE',
    fontSize: theme.typography.pxToRem(10),
  },
  isToday: {
    alignItems: 'center',
    border: `1px solid #229688`,
    borderRadius: '50%',
    display: 'flex',
    height: '100%',
    justifyContent: 'center',
    width: '100%',
  },
  container: {
    '& .DateRangePicker': {
      zIndex: 1000,
      '& .DateRangePickerInput': {
        backgroundColor: 'transparent',
        borderColor: '#8E8E93',
        borderRadius: 0,
        borderWidth: '0 0 1px 0',
        paddingRight: 70,
        '& .DateRangePickerInput_calendarIcon': {
          padding: '5px',
          position: 'absolute',
          right: 0,
        },
        '& .DateInput': {
          background: 'transparent',
          width: 90,
          '& .DateInput_input': {
            background: 'transparent',
            color: '#2C2C2E',
            fontWeight: 400,
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(14),
            padding: '5px 7px 4px',
          },
          '& .DateInput_input__focused': {
            border: 0,
          },
          '& .DateInput_fang': {
            display: 'none',
          },
        },
      },
      '& .DayPickerNavigation_button': {
        background: '#fff',
        border: 0,
        '& svg': {
          display: 'none',
        },
      },
      '& .DayPickerNavigation_leftButton__horizontalDefault': {
        '&::after': {
          fontFamily: 'Material Icons',
          content: "'navigate_before'",
          width: 30,
          height: 29,
          fontWeight: 600,
          fontSize: 16,
          color: '#000',
        },
      },
      '& .DayPickerNavigation_rightButton__horizontalDefault': {
        '&::after': {
          fontFamily: 'Material Icons',
          content: "'navigate_next'",
          // content: "'>'",
          width: 30,
          height: 29,
          fontWeight: 600,
          fontSize: 16,
          color: '#000',
        },
      },
      '& .DayPicker_transitionContainer': {
        height: '280px !important',
      },
      '& .DateRangePickerInput_clearDates': {
        alignItems: 'center',
        display: 'flex',
        height: 25,
        justifyContent: 'center',
        right: 24,
        width: 25,
      },
      '& .DateRangePicker_picker': {
        top: '37px !important',
        '& .CalendarMonth_caption': {
          color: theme.palette.text.primary,
          fontSize: theme.typography.pxToRem(14),
          paddingBottom: 50,
          '& strong': {
            fontWeight: 500,
            color: '#000',
          },
        },
        '& .CalendarDay__default': {
          borderWidth: 0,
          borderRadius: '50%',
          color: '#000',
          fontSize: theme.typography.pxToRem(12),
        },
        '& .CalendarDay__outside': {
          color: theme.palette.text.secondary,
          fontSize: theme.typography.pxToRem(12),
        },
        '& .CalendarDay__selected_start': {
          backgroundColor: '#0181FF26',
          borderColor: '#0181FF26',
          borderRadius: '50% 0 0 50%',
          color: theme.palette.common.white,
          position: 'relative',

          '& span': {
            zIndex: 2,
            position: 'relative',
          },

          '&::after': {
            content: "''",
            width: 30,
            position: 'absolute',
            height: 29,
            top: 0,
            left: 0,
            zIndex: 1,
            borderRadius: '50%',
            background: theme.palette.primary.main,
          },
        },
        '& tr .CalendarDay:last-child': {
          '&.CalendarDay__selected_start': {
            borderColor: theme.palette.common.white,
            backgroundColor: theme.palette.common.white,
          },
        },
        '& .CalendarDay__selected_end': {
          backgroundColor: '#0181FF26',
          borderColor: '#0181FF26',
          borderRadius: '0 50% 50% 0',
          color: theme.palette.common.white,
          position: 'relative',

          '& span': {
            zIndex: 2,
            position: 'relative',
          },

          '&::after': {
            content: "''",
            width: 30,
            position: 'absolute',
            height: 29,
            top: 0,
            left: 0,
            zIndex: 1,
            borderRadius: '50%',
            background: theme.palette.primary.main,
          },
        },
        '& tr .CalendarDay:first-child': {
          '&.CalendarDay__selected_end': {
            borderColor: theme.palette.common.white,
            backgroundColor: theme.palette.common.white,
          },
        },
        '& .CalendarDay__selected_span': {
          backgroundColor: '#0181FF26',
          borderColor: '#0181FF26',
          borderRadius: '0',
          color: '#000',
        },
        '& .DayPicker_weekHeader .DayPicker_weekHeader_ul li small': {
          color: 'rgba(0,0,0,.4)',
          fontSize: theme.typography.pxToRem(12),
        },
      },
    },
  },
}));

export default useStyles;
